import React, { useEffect, useState } from "react";
import { useTheme } from '@mui/material/styles';
import { Grid, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Loader from "react-js-loader";
import { verifyUser } from "../../../redux/actions/auth";

function VerifyUserForm() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [validUrl, setValidUrl] = useState(false);
  const param = useParams();

  useEffect(() => {
    const verifyEmailUrl = async () => {
			try {
        setLoading(true);
        const { success } = await dispatch(verifyUser(param.token));
				setValidUrl(success);
        setLoading(false);
        setTimeout(() => navigate('/login'), 1500);
			} catch (error) {
				console.log(error);
				setValidUrl(false);
			} finally {
        setLoading(false);
      }
    };
    verifyEmailUrl();
  }, []);

  return (
    <Grid
      display="flex"
      alignItems="center"
      justifyContent='center'
      sx={{
        width: { sm: '550px' },
        minHeight: '300px',
        backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d',
        borderRadius: '0.625rem',
        padding: { xs: 4, md: '4rem' }
      }}
    >
      {loading ?
        <Loader type="bubble-loop" bgColor={"#2196f3"} color={'#2196f3'} size={100} /> :
        validUrl ?
          <Typography sx={{ fontWeight: 600, textAlign: 'center', fontSize: '1.4rem' }}>Thank you. Your email has been successfully verified.</Typography> :
          <Typography sx={{ fontWeight: 600, textAlign: 'center', fontSize: '1.4rem' }}>404 Not Found</Typography>
      }
    </Grid>
  );
}

export default VerifyUserForm;
